import { VodItemProps } from '@/types/vod/VodItem'

class VodItem {
    id
    aspectRatio
    assetType
    type
    title
    imageUrl
    productId
    externalUri
    shouldAuthenticateLinkUri
    showDetails
    apiEpochTime
    label
    ord
    position
    duration
    serviceName
    channelId

    constructor(vodItemProps: VodItemProps) {
        this.id = vodItemProps.id
        this.aspectRatio = vodItemProps.aspectRatio
        this.assetType = vodItemProps.productType
        this.type = vodItemProps.type
        this.title = vodItemProps.title
        this.imageUrl = vodItemProps.imageUrl
        this.productId = vodItemProps.productId
        this.externalUri = vodItemProps.externalUri
        this.shouldAuthenticateLinkUri = vodItemProps.shouldAuthenticateLinkUri
        this.showDetails = vodItemProps.showDetails
        this.apiEpochTime = vodItemProps.apiEpochTime
        this.label = vodItemProps.label
        this.ord = vodItemProps.ord
        this.position = vodItemProps.position
        this.duration = vodItemProps.duration
        this.serviceName = vodItemProps.serviceName
        this.channelId = vodItemProps.channelId
    }

    parseAspectRatioToNumber = (): number => {
        if (this.aspectRatio) {
            const parts = this.aspectRatio.split(':')
            const width = parseInt(parts[0])
            const height = parseInt(parts[1])
            if (width && height) {
                const numberRatio = width / height
                if (numberRatio) return numberRatio
            }
        }
        return 2 / 3
    }
}

export default VodItem
